import { render, staticRenderFns } from "./InputCurrency.vue?vue&type=template&id=2a5521c0&"
import script from "./InputCurrency.vue?vue&type=script&lang=js&"
export * from "./InputCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports